import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

const gbp = (v) => `£${(parseFloat(v) || 0).toFixed(2)}`;

export const BulkLinkBar = ({ category, count, targets, onApply, onClear }) => {
  const [target, setTarget] = useState('');
  if (!count) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 p-3 rounded-lg border border-primary/40 bg-primary/5" data-testid={`bulk-link-bar-${category}`}>
      <span className="text-sm font-medium">{count} selected - add them together into:</span>
      <Select value={target} onValueChange={setTarget}>
        <SelectTrigger className="h-8 w-64 text-xs" data-testid={`bulk-link-target-${category}`}><SelectValue placeholder="Choose a field" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {targets.map(t => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button size="sm" disabled={!target} onClick={() => { onApply(target); setTarget(''); }} data-testid={`bulk-link-apply-${category}`}>Link selected</Button>
      <Button size="sm" variant="ghost" onClick={onClear} data-testid={`bulk-link-clear-${category}`}>Clear</Button>
    </div>
  );
};

export const GroupSummary = ({ category, items, targets, effectiveOf }) => {
  const groups = {};
  items.forEach(i => {
    const t = effectiveOf(i);
    if (t && t !== 'ignore' && t !== 'other') (groups[t] = groups[t] || []).push(i);
  });
  const combined = Object.entries(groups).filter(([, list]) => list.length > 1);
  if (!combined.length) return null;
  return (
    <div className="rounded-lg border p-3 space-y-1" data-testid={`group-summary-${category}`}>
      <p className="text-xs font-semibold uppercase text-muted-foreground">Added together</p>
      {combined.map(([t, list]) => (
        <div key={t} className="flex flex-wrap justify-between gap-2 text-sm" data-testid={`group-summary-row-${t}`}>
          <span><span className="font-medium">{targets.find(x => x.value === t)?.label || t}</span>
            <span className="text-muted-foreground"> = {list.map(i => i.name).join(' + ')}</span></span>
          <span className="font-mono">{gbp(list.reduce((s, i) => s + (i.amount || 0), 0))}</span>
        </div>
      ))}
    </div>
  );
};
